import ResultVisualizationPredefinedFilter from "../../components/ResultVisualizationFilter/ResultVisualizationPredefinedFilter";
import ClusterCard from "../StatisticalForecastAnalysis/Clustercard/clusterCard";
import TimeCardComponent from "../StatisticalForecastAnalysis/Timecard/TimeCardComponent";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import ResultVisulizationBacktestingResults from "./ResultVisulizationBacktestingResults";
import { useOktaAuth } from '@okta/okta-react';
import { resultVisualisationFilterExperimentaionApi } from '../../api/forecastPageApi';
import { useEffect } from 'react';
import { setExperimentId } from '../../store/resultVisualizationExperimentation';

const PredefinedRuns = () => {
  const dispatch = useDispatch();
  const { authState } = useOktaAuth();
  const userData = useSelector((state: RootState) => state.user.currentSector);
  const filter = useSelector(
    (state: RootState) => state.resultVisualizationFilter
  );
  const expermentationPayload = {
    shortTermMidTermCode: filter?.term.toString(),
    sector: userData?.sector,
    market: userData?.market,
  };
  
  useEffect(() => {
   if(userData?.sector !== undefined && userData?.sector ==='LATAM' && userData?.market !== undefined) {
      resultVisualisationFilterExperimentaionApi(
        expermentationPayload,
        authState
      ).then((data) => {
        dispatch(setExperimentId(data));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData, filter]);



  return (
    <>
      <div className="flex space-x-3 mt-5">
        <div className='flex min-w-[30%] p-2 bg-secondary-bg rounded h-64'>
          <TimeCardComponent lag={false} label="Rundate" isDisabled={false} />
        </div>
        <div className="flex-auto max-w-[70%]">
          <ClusterCard />
        </div>
      </div>
      <ResultVisualizationPredefinedFilter />
      
    </>
  );
};

export default PredefinedRuns;
